import { render } from "./LuxuryTravel.vue?vue&type=template&id=779b49fd&scoped=true"
import script from "./LuxuryTravel.vue?vue&type=script&lang=js"
export * from "./LuxuryTravel.vue?vue&type=script&lang=js"

import "./LuxuryTravel.scss?vue&type=style&index=0&id=779b49fd&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779b49fd"]])

export default __exports__